/**
 * TanStack Query hooks for `publisher-vs-publisher-comparison-widget`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	publisherVsPublisherComparisonWidgetQueryKeys,
	type CreatePublisherVsPublisherComparisonWidgetBody,
	type ListPublisherVsPublisherComparisonWidgetResponse,
	type PublisherVsPublisherComparisonWidgetRow,
} from "./api";

export function usePublisherVsPublisherComparisonWidgetList(): UseQueryResult<ListPublisherVsPublisherComparisonWidgetResponse, Error> {
	return useQuery({
		queryKey: publisherVsPublisherComparisonWidgetQueryKeys.list(),
		queryFn: list,
	});
}

export function usePublisherVsPublisherComparisonWidgetCreate(): UseMutationResult<PublisherVsPublisherComparisonWidgetRow, Error, CreatePublisherVsPublisherComparisonWidgetBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: publisherVsPublisherComparisonWidgetQueryKeys.all });
		},
	});
}

export function usePublisherVsPublisherComparisonWidgetDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: publisherVsPublisherComparisonWidgetQueryKeys.all });
		},
	});
}
